import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface ErrorState {
   key: string;
}

export function createInitialErrorState(): ErrorState {
  return {
    key: ''
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'error' })
export class ErrorStore extends Store<ErrorState> {

  constructor() {
    super(createInitialErrorState());
  }

}

